// 近隣検索
export default class {
  constructor() {
    const locationBtn = document.getElementById('location-btn');
    if (locationBtn != null) {
      locationBtn.onclick = generate_map;
    }

    var ready = { api: false, ajax: false };
    var map;
    var mapData;

    function get_json(position) {
      var latitude = position.coords.latitude;//緯度
      var longitude = position.coords.longitude;//経度
      // console.log(latitude, longitude);
      $(function () {
        $.ajax({
          // url: '/api/search/clinics/coordinate?latitude=43.113617500000004&longitude=141.3623726&radius=5',
          url: '/api/search/clinics/coordinate?latitude=' + latitude + '&longitude=' + longitude + '&radius=5',
          dataType:'json',
          cache: false
        })
          .then(
            function (data) {
              mapData = data;
              ready['ajax'] = true;
              if (mapData.length > 0) {
                add_marker();
              } else {
                no_results();
              }
            },
            function () {
              $.ajax({
                // url: '/_assets/json/data.json',
                // url: '/_assets/json/data_api_blank.json',
                url: '/_assets/json/data_api.json',
                dataType:'json',
                cache: false
              })
                .then(
                  function (data) {
                    mapData = data;
                    // console.log(mapData.length);
                    ready['ajax'] = true;
                    if (mapData.length > 0) {
                      add_marker();
                    } else {
                      no_results();
                    }
                  },
                  function () {
                    console.log('取得に失敗しました。');
                  }
                );
            }
          );
      });
    }

    /**
     * 地図を生成する
     */
    function generate_map() {
      document.getElementById('result').style.display = 'block';
      var state = document.getElementById('state');
      var output = document.getElementById('output');
      function success(position) {
        var latitude = position.coords.latitude;//緯度
        var longitude = position.coords.longitude;//経度
        if (output != null) {
          output.innerHTML = '<p>緯度 ' + latitude + '° <br>経度 ' + longitude + '°</p>';
        }
        get_json(position);
        // 位置情報
        var latlng = new google.maps.LatLng(latitude, longitude);
        // Google Mapsに書き出し
        map = new google.maps.Map(document.getElementById('map'), {
          center: latlng,// 中心座標
          zoom: 14, // 地図の拡大率
          // zoom: 4, // 地図の拡大率
          gestureHandling: 'auto', // 拡大・移動の操作挙動
          mapTypeControl: false, // マップ切り替えのコントロールを表示するかどうか
          streetViewControl: false // ストリートビューのコントロールを表示するかどうか
        });
        // add_marker();
        // マーカーの新規出力
        new google.maps.Marker({
          map: map,
          position: latlng,
        });
      };
      function error() {
        //エラーの場合
        state.innerHTML = "座標位置を取得できません";
      };
      navigator.geolocation.getCurrentPosition(success, error);//成功と失敗を判断
    }

    /**
     * 地図にマーカーを追加する
     */
    function add_marker() {
      var htmlString = '';
      // console.log(mapData.length);
      if ( document.querySelector('#result-num') != null ) {
        document.querySelector('#result-num').innerHTML = mapData.length;
      }
      for (var i = 0; i < mapData.length; i++) {
        var item = mapData[i];

        // マーカーの設置

        var latlng = item['coordinate'];
        latlng = latlng.split(', ');
        var marker = new google.maps.Marker({
          position : {
            lat : parseFloat( latlng[0] ),
            lng : parseFloat( latlng[1] )
          },
          icon: "/_assets/images/common/icon-mappin.svg",
          map: map
        });

        // 吹き出しの生成
        var linktext = '';
        if( item['type'] === 0 ) {
          linktext = '予約代行を依頼';
        } else {
          linktext = '詳細を見る';
        }
        // console.log(linktext);
        var ins = '<div class="map-info">';
        ins += '<p class="map-info_name">' + item['name'] + '</p>';
        ins += '<p class="map-info_link"><a href="' + item['_url'] + '">' + linktext + '</a></p>';
        ins += '</div>';
        var infoWindow = new google.maps.InfoWindow({
          content: ins
        });

        // マーカーのイベント設定
        add_event_to_marker(marker, infoWindow, i);

        htmlString += '<li class="hospitalList_item">';
        htmlString += '<a class="hospitalList_link" href="' + item['_url'] + '">';
        htmlString += '<div class="hospitalList_head">';
        htmlString += '<p class="hospitalList_pin"><img src="/_assets/images/common/icon-mappin.svg" alt=""></p>';
        htmlString += '<p class="hospitalList_range">' + item['_distance'] + 'km</p>';
        htmlString += '</div>';
        htmlString += '<div class="hospitalList_body">';
        htmlString += '<p class="hospitalList_ttl">' + item['name'] + '</p>';
        htmlString += '<p class="hospitalList_address">' + item['address'] + item['address2'] + '</p>';
        htmlString += '</div>';
        htmlString += '</a>';
        htmlString += '</li>';
      }
      document.querySelector('#result-list').innerHTML = htmlString;
    }

    function no_results () {
      // console.log('blank');
      document.querySelector('#result').classList.add('-noResults');
    }

    /**
     * マーカーにイベントを追加する
     * @param {object} marker     (required) マーカーの情報
     * @param {object} infoWindow (required) 吹き出しの情報
     * @param {number} index      (required) 地図情報のインデックス番号
     */
    function add_event_to_marker(marker, infoWindow, index) {
      var item = mapData[index];
      item['marker'] = marker;
      item['infoWindow'] = infoWindow;

      // マーカークリック時に吹き出しを表示する
      item['marker'].addListener('click', function (e) {
        infoWindows_hide();
        item['infoWindow'].open(map, item['marker']);
      });
    }

    /**
     * 吹き出しを非表示にする
     */
    function infoWindows_hide() {
      for (var i = 0; i < mapData.length; i++) {
        mapData[i]['infoWindow'].close();
      }
    }
  }
}
